import {
  PLATFORM_CERTIFICATE_FETCH_REQUEST,
  PLATFORM_CERTIFICATE_FETCH_REQUEST_SUCCESS,
  PLATFORM_CERTIFICATE_FETCH_REQUEST_FAILURE,
  PLATFORM_CERTIFICATE_ADD_REQUEST,
  PLATFORM_CERTIFICATE_ADD_REQUEST_SUCCESS,
  PLATFORM_CERTIFICATE_ADD_REQUEST_FAILURE,
  PLATFORM_CERTIFICATE_UPDATE_REQUEST,
  PLATFORM_CERTIFICATE_UPDATE_REQUEST_SUCCESS,
  PLATFORM_CERTIFICATE_UPDATE_REQUEST_FAILURE,
  PLATFORM_CERTIFICATE_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const platformCertificatesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case PLATFORM_CERTIFICATE_FETCH_REQUEST:
    case PLATFORM_CERTIFICATE_ADD_REQUEST:
    case PLATFORM_CERTIFICATE_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case PLATFORM_CERTIFICATE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case PLATFORM_CERTIFICATE_ADD_REQUEST_SUCCESS:
    case PLATFORM_CERTIFICATE_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case PLATFORM_CERTIFICATE_FETCH_REQUEST_FAILURE:
    case PLATFORM_CERTIFICATE_ADD_REQUEST_FAILURE:
    case PLATFORM_CERTIFICATE_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case PLATFORM_CERTIFICATE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default platformCertificatesReducer;
